document.addEventListener('DOMContentLoaded', function() {
    let fixedElement = document.querySelector('.add-to-cart-fixed');
    let stickyElement = document.querySelector('.buy-button-sticky-container');
    
    function checkVisibility() {
        let rect = fixedElement.getBoundingClientRect();
        let isAboveViewport = rect.bottom < 0;

        if (isAboveViewport) {
            stickyElement.classList.add('active');
        } else {
            stickyElement.classList.remove('active');
        }
    }

    // Verificar visibilidad al cargar la página
    checkVisibility();

    // Verificar visibilidad al hacer scroll
    document.addEventListener('scroll', checkVisibility);
});